import React from "react";
import CreatePrompt from './CreatePrompt';

export default function App() {
  return (
    <div>
      <CreatePrompt />
    </div >
  )
}